module.exports = __webpack_public_path__ + "static/img/bannerBg.a76de1de.png";